import { Directive, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { emailPatternValidator } from '../../utils';

@Directive()
export abstract class LoginFormKeyckloakBaseComponent {
  @Output() loginTapped = new EventEmitter();
  @Output() loginSuccess = new EventEmitter();
  @Output() forgotTapped = new EventEmitter();
  @Output() formSubmit = new EventEmitter();
  fg: FormGroup = this.fb.group({
    email: ['', [Validators.required, emailPatternValidator()]],
  });
  protected submitAttempted = false;

  protected constructor(private fb: FormBuilder) {}

  submit(fg: FormGroup) {
    this.markSubmitAttempted();
    if (fg.valid) {
      this.formSubmit.next(fg.value);
    }
  }

  // Enhanced validation methods - only show errors after submit is attempted
  protected shouldShowFieldError(fieldName: string): boolean {
    if (!this.submitAttempted) {
      return false;
    }
    const control = this.fg.get(fieldName);
    return !!control?.invalid;
  }

  protected getFieldErrorMessage(fieldName: string): string {
    const control = this.fg.get(fieldName);
    if (!control?.errors) {
      return '';
    }

    if (control.errors['required']) {
      return 'forms.required_l';
    }
    if (control.errors['invalidEmail']) {
      return 'registration_email_valid_l';
    }
    return '';
  }

  protected getEmailErrorState(): boolean {
    return this.shouldShowFieldError('email');
  }

  protected markSubmitAttempted(): void {
    this.submitAttempted = true;
  }
}
